export enum AttackTarget {
  Player = "Player",
  Enemy = "Enemy",
  Summon = "Summon",
}
